import { ResponsiveMapType } from './types'

export const twBlock: ResponsiveMapType = {
  sm: {
    sm: 'ds-block',
    md: 'md:ds-block',
    lg: 'lg:ds-block'
  },
  md: {
    sm: 'ds-block',
    md: 'md:ds-block',
    lg: 'lg:ds-block'
  },
  lg: {
    sm: 'ds-block',
    md: 'md:ds-block',
    lg: 'lg:ds-block'
  },
  default: {
    sm: 'ds-block',
    md: 'md:ds-block',
    lg: 'lg:ds-block'
  }
}

export default twBlock
